export default __webpack_public_path__ + "static/media/about.574e12cc.png";